module.exports = __webpack_public_path__ + "img/heating-type-03-label-es.asset.ca6e88f9.svg";